import React, {useCallback, useEffect, useState} from "react";
import {BaseModal} from "./modalStyle";
import styled, {css} from "styled-components";
import {FunctionalModal} from "./FunctionalModal";
import EnjoyNewsPDF from "../enjoyNews/EnjoyNewsPDF";
import {useSelector} from "react-redux";
import {getImage, getWeatherImage, removeDuplicatesInArray} from "../../utils/utils";
import exitButton from "../buttons/ExitButton";
import axisSvg from "../../images/axis/axis.svg";
import _ from "lodash";
import accountSvg from "../../images/account.svg";
import ENprefilter from "../../images/EnjoyNews/ENprefilter.png"


const EnjoyNewsModal = ({setOpen}) => {
    const {axis} = (useSelector(state => (state.axis)))
    const strategicAxis = axis.filter(a => a.isStrategic)
    const stakes = strategicAxis.map(a => a.stakes).flat()
    const strategicProjectsFromStakes = stakes.map(s => s.projects).flat()
    const {projects} = useSelector(state => state.projects)
    const strategicProjects = projects?.filter(p => p.isStrategic === true);
    const strategicPilots = removeDuplicatesInArray(strategicAxis.map(a => a.stakes.map(s =>s.projects.map(p => p.pilot).flat()).flat()).flat())
    const [filter, setFilter] = useState({
        axisId: [],
        years: [],
        pilotsId: [],
        weathers: [],
        tags: []

    });
    const [seeFilter, setSeeFilter] = useState(false);
    const clearFilter = () => {
        setFilter({
            axisId: [],
            years: [],
            pilotsId: [],
        })
    }
    const close = () => {
        setOpen(false)
    }
    const [isStartedEN, setIsStartedEN] = useState(false)
    const [asideObjective, setAsideObjective] = useState(false)
    const [showKR, setShowKR] = useState(false)
    const startEnjoyNews = () => {
        setIsStartedEN(true)
    }
    const ContainerFilter = ({ title, count, onReset, children }) => {
    const Container = styled.div`
      overflow-y: scroll;
      overflow-x: hidden;
      margin-bottom: 24px;
      max-height: 260px;


        ::-webkit-scrollbar {
        width: 6px;
        background-color: transparent;
      }
    
      ::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
        background-color: var(--color-purple);
      }
  `;

        return (
            <div >
                <div
                    style={{
                        display: "flex",
                        paddingLeft: 12,
                        paddingRight: 12,
                        paddingTop: 6,
                        paddingBottom: 6,
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 12,
                        borderLeft: "4px solid var(--color-purple)",
                        borderRight: "4px solid var(--color-purple)",
                        borderRadius: 12,
                        background: "var(--color-grey-03)",
                        cursor: "pointer",
                        userSelect: "none",
                    }}
                >
                    <p
                        style={{
                            fontSize: 16,
                            color: "var(--color-purple)",
                        }}
                    >
                        {title} {count ? `(${count})` : ""}
                    </p>

                </div>

                <Container>
                    {children}
                </Container>
            </div>
        );
    };
    const AxisFilter = ({filter, onChange}) => {
        return (
            <ContainerFilter
                title="Axes"
                count={filter.axisId.length}
                onReset={() => onChange([])}
            >
                {
                    strategicAxis.map((a) => (
                    <div
                        key={"axis" + a.id}
                        title={a.name}
                        style={{
                            cursor: "pointer",
                            display: "flex",
                            gap: 4,
                        }}
                        onClick={() => {
                            if (filter.axisId.includes(a.id)) {
                                onChange(filter.axisId.filter((id) => id !== a.id));
                            } else {
                                onChange([...filter.axisId, a.id]);
                            }
                        }}
                    >
                        <input type="checkbox" checked={filter.axisId.includes(a.id)}/>

                        <div style={{display: "flex", gap: 4}}>
                            <img
                                style={{
                                    width: 22,
                                    height: 22,
                                    background: "var(--color-white)",
                                    borderRadius: "50%",
                                }}
                                src={getImage(a.image, axisSvg)}
                                alt={a.name}
                            />
                            <p
                                style={{
                                    fontSize: 13,
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    overflow: "hidden",
                                    maxWidth: 250,
                                }}
                            >
                                {a.name}
                            </p>
                        </div>
                    </div>
                ))}
            </ContainerFilter>
        );
    };

    const PilotsFilter = ({ projects, filter, onChange }) => {
        const getPilots = useCallback(() => {
            const pilots = projects
                .filter(
                    (p) =>
                        filter.axisId.includes(p.stake?.axisId) || filter.axisId.length === 0
                )
                .map((p) => p.pilot);
            return _.uniqBy(pilots, "id");
        }, [filter.axisId, projects]);


        return (
            <ContainerFilter
                title="Pilotes"
                count={filter.pilotsId.length}
                onReset={() => onChange([])}
            >
                {getPilots().map((p) => (
                    <div
                        key={"pilot" + p.id}
                        style={{
                            cursor: "pointer",
                            display: "flex",
                            gap: 24,
                        }}
                        onClick={() => {
                            if (filter.pilotsId.includes(p.id)) {
                                onChange(filter.pilotsId.filter((id) => id !== p.id));
                            } else {
                                onChange([...filter.pilotsId, p.id]);
                            }
                        }}
                    >
                        <input type="checkbox" checked={filter.pilotsId.includes(p.id)} />
                        <img
                            style={{
                                width: 22,
                                height: 22,
                                background: "var(--color-white)",
                                borderRadius: "50%",
                            }}
                            src={getImage(p.photo, accountSvg)}
                            alt={p.name}
                        />
                        <p
                            style={{
                                fontSize: 13,
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                maxWidth: 300,
                            }}
                        >
                            {p.firstName + " " + p.lastName}
                        </p>
                    </div>
                ))}
            </ContainerFilter>
        );
    };
    const YearsFilter = ({ projects, filter, onChange }) => {
        const getYears = useCallback(() => {
            const years = projects
                .map((p) =>
                    p.endDate ? p.endDate : p.startDate ? p.startDate : p.lastUpdate
                )
                .filter((d) => d)
                .map((d) => new Date(d).getFullYear());

            return [...new Set(years)].sort((a, b) => a - b);
        }, [projects]);

        return (
            <ContainerFilter title="Année" count={0} onReset={() => onChange([])}>
                {getYears().map((year) => (
                    <div
                        key={year}
                        style={{
                            cursor: "pointer",
                            display: "flex",
                            gap: 8,
                        }}
                        onClick={() => {
                            if (filter.years.includes(year)) {
                                onChange(filter.years.filter((x) => x !== year));
                            } else {
                                onChange([year]);
                            }
                        }}
                    >
                        <input type="checkbox" checked={filter.years.includes(year)} />

                        <p
                            style={{
                                fontSize: 13,
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                maxWidth: 300,
                            }}
                        >
                            {year}
                        </p>
                    </div>
                ))}
            </ContainerFilter>
        );
    };
    const WeatherFilter = ({ filter, onChange }) => {
        const weathers = ["sunny", "cloudy", "rainy", "stormy"];

        return (
            <ContainerFilter
                title="Météo"
                count={filter.weathers.length}
                onReset={() => onChange([])}
            >
                {weathers.map((w) => (
                    <div
                        key={w}
                        style={{
                            cursor: "pointer",
                            display: "flex",
                            gap: 8,
                        }}
                        onClick={() => {
                            if (filter.weathers.includes(w)) {
                                onChange(filter.weathers.filter((x) => x !== w));
                            } else {
                                onChange([...filter.weathers, w]);
                            }
                        }}
                    >
                        <input type="checkbox" checked={filter.weathers.includes(w)} />
                        <img
                            src={getWeatherImage(w)}
                            height={35}
                            width={35}
                            alt="icone météo"
                        />

                        <p
                            style={{
                                fontSize: 13,
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                maxWidth: 300,
                            }}
                        >
                            {w.name}
                        </p>
                    </div>
                ))}
            </ContainerFilter>
        );
    };
    const TagsFilter = ({ filter, onChange }) => {
        const { tagCategories } = useSelector((state) => state.tagCategories);
        return (
            <ContainerFilter
                title="Tags"
                count={filter.tags.length}
                onReset={() => onChange([])}
            >
                {tagCategories?.map((tc) => (
                    <div key={tc.id}>
                        <div
                            style={{
                                cursor: "pointer",
                                display: "flex",
                                gap: 8,
                            }}
                            onClick={() => {
                                if (filter.tags.includes(tc.name)) {
                                    onChange(filter.tags.filter((x) => x !== tc.name));
                                } else {
                                    onChange([...filter.tags, tc.name]);
                                }
                            }}
                        >
                            <input type="checkbox" checked={filter.tags.includes(tc.name)} />
                            <p>{tc.name}</p>
                        </div>

                        {tc.tags?.map((t) => (
                            <div
                                key={t.id}
                                style={{
                                    cursor: "pointer",
                                    display: "flex",
                                    gap: 8,
                                }}
                                onClick={() => {
                                    if (filter.tags.includes(t.name)) {
                                        onChange(filter.tags.filter((x) => x !== t.name));
                                    } else {
                                        onChange([...filter.tags, t.name]);
                                    }
                                }}
                            >
                                <input type="checkbox" checked={filter.tags.includes(t.name)} />
                                <p>
                                    {tc.name} / {t.name}
                                </p>
                            </div>
                        ))}
                    </div>
                ))}
            </ContainerFilter>
        );
    };
    const filterPredicate = useCallback(
        (p) => {
            let year;
            p.stakes.some(s => s.projects.map(project => {
                if (project.endDate) {
                    year = new Date(project.endDate).getFullYear();
                } else if (project.startDate) {
                    year = new Date(project.startDate).getFullYear();
                } else if (project.lastUpdate) {
                    year = new Date(project.lastUpdate).getFullYear();
                }
                return year
            }))
            const pilotFilter =
                filter.pilotsId.length === 0 || p.stakes.some(s => s.projects.some(project => filter.pilotsId.includes(project.pilot.id)))
            const weatherFilter =
                filter.weathers.length === 0 || p.stakes.some(s => s.projects.some(project => filter.weathers.includes(project.weather)))
            const tagsFilter =
                filter.tags.length === 0 || p.stakes.some(s => s.projects.some((p) => {
                    return p.tags.some(t => filter.tags.includes(t.name))
                }))
            const axisFilter =
                filter.axisId.length === 0 || filter.axisId.includes(p.id);
            const yearFilter =
                (filter.years.length === 0) || filter.years.includes(year);
            return (
                pilotFilter &&
                axisFilter &&
                yearFilter &&
                weatherFilter &&
                tagsFilter
            );
        },
        [filter]
    );
    return(
        <FunctionalModal setOpen={setOpen} component={
            <Modal $mode={seeFilter}>
                <Exit closeUpdate={close}/>
                <TitleEnjoyNewsModal>
                    <div className="image">
                        <img className="img-enjoy-news" src={ENprefilter} alt=""/>
                    </div>
                    <div className={"title-checkbox"}>
                        <h2>EnjoyNews</h2>
                        <PreFilterBlock>
                            <PreFilterSubSection>
                                <h3>Type d'affichage</h3>
                                <div className={"displayFilter"} onClick={() => {
                                    setAsideObjective(true)
                                }}>
                                    <input type="radio" checked={asideObjective} onSelect={() => {
                                        setAsideObjective(true)
                                    }}/>
                                    <p>Objectifs et projets séparément par axe</p>
                                </div>
                                <div className={"displayFilter"} onClick={() => {
                                    setAsideObjective(false)
                                }}>
                                    <input type="radio" checked={!asideObjective} onSelect={() => {
                                        setAsideObjective(false)
                                    }}/>
                                    <p>Objectifs intégrés dans les projets par axe</p>
                                </div>
                            </PreFilterSubSection>
                            <PreFilterSubSection>
                                <h3>Type de données</h3>
                                <div className={"displayFilter"} onClick={() => {
                                    setSeeFilter(false)
                                }}>
                                    <input type="radio" checked={!seeFilter} onChange={() => {
                                        setSeeFilter(false)
                                    }}/>
                                    <p>Toutes</p>
                                </div>
                                <div className={"displayFilter"} onClick={() => {
                                    setSeeFilter(true)
                                }}>
                                    <input type="radio" checked={seeFilter} onChange={() => {
                                        setSeeFilter(true)
                                    }}/>
                                    <p>Filtrer</p>
                                </div>
                            </PreFilterSubSection>
                            <PreFilterSubSection>
                                <h3>Plus de détails ?</h3>
                                <div className={"displayFilter"} onClick={() => {
                                    if (!asideObjective) {
                                        setShowKR(!showKR)
                                    }
                                }}>
                                    <input type="checkbox" disabled={asideObjective} checked={showKR} onChange={() => {
                                        setShowKR(!showKR)
                                    }}/>
                                    <p>Ajout des indicateurs</p>
                                </div>
                            </PreFilterSubSection>
                        </PreFilterBlock>

                        {
                            strategicAxis.filter(filterPredicate).length === 0 &&
                            <div className={"error-message"}>
                                <p>Aucun axe stratégique trouvé avec la sélection</p>
                            </div>
                        }
                    </div>
                </TitleEnjoyNewsModal>
                {
                    seeFilter &&
                    <FilterBlock>
                    <AxisFilter filter={filter} onChange={(values) =>
                            setFilter((prev) => ({...prev, axisId: values}))
                        }/>
                        <PilotsFilter filter={filter} projects={strategicProjects} onChange={(values) =>
                            setFilter((prev) => ({...prev, pilotsId: values}))}
                        />
                        <YearsFilter filter={filter} onChange={(values) => {
                            setFilter((prev) => ({...prev, years: values}))
                        }} projects={strategicProjects}/>
                        <WeatherFilter filter={filter} onChange={(values) => {
                            setFilter((prev) => ({...prev, weathers: values}))
                        }}
                        />
                        <TagsFilter filter={filter} onChange={(values) => {
                            setFilter((prev) => ({...prev, tags: values}))
                        }}/>
                    </FilterBlock>
                }
                <EnjoyNewsButton disabled={strategicAxis.filter(filterPredicate).length === 0}
                                 onClick={startEnjoyNews}>Lancer</EnjoyNewsButton>
                {
                    isStartedEN && strategicAxis.filter(filterPredicate).length > 0 &&
                    <EnjoyNewsPDF axis={strategicAxis.filter(filterPredicate)} close={close} pilots={filter.pilotsId} years={filter.years}
                                  weathers={filter.weathers} tags={filter.tags} asideObjective={asideObjective} showKR={showKR}/>
                }
            </Modal>
        }>

        </FunctionalModal>
    )
}

const Modal = styled(BaseModal)`
  max-width: 70%;
  max-height: 70%;
  min-width: 350px;
  display: flex;
  flex-direction: column;
  .exit-btn {
    max-width: 5%;
    align-self: end;
  }
  overflow-y: scroll;
  
  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    background-color: var(--color-purple);
  }
  @media screen and (min-width: 900px){
    overflow-y: initial;
  }
  ${(props) => {
      switch (props.$mode) {
        case true:
            return css`
              max-width: 90%;
              max-height: 75%;
            `;
        case false:
            return css`
              max-width: 70%;
              max-height: 35%;
                @media screen and (max-width: 900px){
                    max-height: 50%;
                }
            `;
        default:
            return
      }
  }}
`
const Exit = styled(exitButton)`
  
`

const EnjoyNewsButton = styled.button`
  padding: 1rem;
  background-color: #3394F6;
  color: white;
  border-radius: 15px;
  max-width: 110px;
  text-align: center;
  align-self: center;
  cursor: pointer;
  margin-top: 1rem;
  border: none;
  
  @media screen and (min-width: 900px){
    position: absolute;
    bottom: 10px;
  }
`
const PreFilterBlock = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(70%, 100%));
    grid-template-rows: repeat(2, minmax(60%, 100%));
    gap: 0.5rem;
    
    @media screen and (max-width: 1000px) {
        display: flex;
        flex-direction: column;
    }
`
const PreFilterSubSection = styled.div`
    display: flex;
    gap: 0.3rem;
    flex-direction: column;
`
const FilterBlock = styled.div`
  display: grid;
  justify-content: center;
  @media screen and (min-width: 900px){
    grid-gap: 1rem;
    grid-template-columns: 25% 20% 10% 10% 25%;
    height: 70%;
    overflow-y: hidden;
  }
`
const TitleEnjoyNewsModal = styled.div`
  h2{
    color: #5e2ca5;
    margin: 0.5rem 0;
    font-family: 'Archivo Black', sans-serif;
    font-size: 45px;
    text-align: center;
  }
  .displayFilter{
    display: flex;
    gap: 1rem;
    align-self: flex-start;
    justify-content: center;
    cursor: pointer;
    p{
      font-size: 12px;
    }
  }
  margin-bottom: 2rem;
  .error-message p{
    color: var(--color-red)
  }
  display: grid;
  grid-template-columns: 30% 70%;
  
  .image{
    display: flex;
    justify-content: right ;
    margin-right: 1rem;
    .img-enjoy-news{
      max-width: 50%;
      height: 75px;
    }
  }
  
  .title-checkbox{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`
export default EnjoyNewsModal